/* Deeplinks */
(function () {

    const $deeplinks = $('[data-ext="deeplink"]');
    if (!$deeplinks.length) return false;

    // foreach all deeplinks on the page
    $deeplinks.each(function () {
        const $deeplink = $(this);
        const dpVersion = parseInt($deeplink.data('version')) || 1;
        const linkAppDataMobile = $deeplink.attr("data-deeplink-mobile");
        const linkAppDataDesktop = $deeplink.attr("data-deeplink-desktop");
        const linkDeoData = $deeplink.attr("data-deeplink-deo");
        const linkFixed = $deeplink.attr("data-fixed");
        const linkAbsolute = $deeplink.attr("data-absolute");
        const notGenerateDeeplink = (typeof $deeplink.data('deeplink-no-generate') !== 'undefined');
        const showIdAttr = (typeof $deeplink.data('deeplink-show-id-attr') !== 'undefined');

        if (notGenerateDeeplink) return true;

        if (dpVersion === 1) {
            const linkActive = $deeplink.attr("data-active");
            const linkAppHtml = '<div class="u-fs--fo u-fw--semibold u-uppercase u-bl">Open in SLR App</div>';
            const linkDeoHtml = '<div class="u-fs--fo u-fw--semibold u-uppercase u-bl">Open in DeoVR</div>';
            const downloads = '<div class="m-deeplinks-downloads">\
                <div class="m-deeplinks-downloads-android js-m-deeplinks-downloads-slider u-inline-block u-lh--zero">\
                    <div class="js-m-deeplinks-slide m-deeplinks-downloads-img google-play--w"></div>\
                    <div class="js-m-deeplinks-slide m-deeplinks-downloads-img gear--w"></div>\
                    <div class="js-m-deeplinks-slide m-deeplinks-downloads-img daydream--w"></div>\
                    <div class="js-m-deeplinks-slide m-deeplinks-downloads-img oculus--w"></div>\
                    <div class="js-m-deeplinks-slide m-deeplinks-downloads-img steam--w"></div>\
                </div>\
                <div class="m-deeplinks-downloads-ios u-inline-block u-lh--zero">\
                    <div class="js-m-deeplinks-slide m-deeplinks-downloads-img appstore--w"></div>\
                </div>\
            </div>';

            let $deeplinkIn = $('<div>', {
                'class': 'm-deeplinks u-nowrap u-flex u-flex-row u-align-i--start'
            });

            if (linkAbsolute) {
                $deeplinkIn.addClass('m-deeplinks--absolute u-absolute u-fade');
            }

            let $deeplinkInFixed = $('<div>', {
                'class': 'm-deeplinks m-deeplinks--fixed u-fixed u-nowrap u-flex-row u-align-i--start u-fade u-none tablet:u-flex desktop:u-flex'
            });

            // Change position if cookieNotice disabled or confirmed
            document.addEventListener('cookieNoticeDisable', function () {
                $deeplinkInFixed.removeClass('m-deeplinks--bottom-space');
            }, false);

            // Change position if cookieNotice enabled
            document.addEventListener('cookieNoticeEnable', function () {
                $deeplinkInFixed.addClass('m-deeplinks--bottom-space');
            }, false);

            $deeplink.append($deeplinkIn);
            if (linkFixed) {
                $deeplink.append($deeplinkInFixed);
            }

            if (linkActive === 'deo') {
                $deeplink.find('.m-deeplinks').addClass('m-deeplinks--ordered');
            }

            if (linkDeoData && linkDeoData.length) {
                let deoIdAttr = null;
                if (showIdAttr) {
                    deoIdAttr = 'js-deeplink--deo';
                }
                let linkDeo = $('<a>', {
                    'href': '#',
                    'id': deoIdAttr,
                    'class': 'o-btn o-btn--deeplink o-btn--deeplink-deo o-btn--active u-ml--two u-overflow--hidden u-relative u-l js-deeplink--deo'
                });

                if (linkAppDataMobile && linkAppDataMobile.length) {
                    if (linkActive === 'deo') {

                    } else {
                        linkDeo.removeClass('o-btn--active');
                    }

                }

                let linkDeoHandler = $('<a>', {
                    'href': '#',
                    'class': 'u-none-i js-m-modal js-deo-handler',
                    'data-deeplink-handler': 'deo',
                    'data-modal-target': 'dl_Deo',
                    'data-modal-effect': 'slideUpIn'
                });

                $deeplink.append(linkDeoHandler);

                linkDeo.prepend(linkDeoHtml);

                $('#desktop-deovr-link').attr('href', linkDeoData);
                $('#mobile-deovr-link').attr('href', linkDeoData);

                if (linkActive === 'deo') {
                    $deeplink.find('.m-deeplinks').append(linkDeo);
                } else {
                    $deeplink.find('.m-deeplinks').prepend(linkDeo);
                }

                // add download links to absolute deo deeplinks
                $deeplink.find('.m-deeplinks--absolute .o-btn--deeplink-deo').append(downloads);

            }

            if (linkAppDataMobile && linkAppDataMobile.length) {
                let appIdAttr = null;
                if (showIdAttr) {
                    appIdAttr = 'js-deeplink--app';
                }
                let linkApp = $('<a>', {
                    'href': '#',
                    'id': appIdAttr,
                    'class': 'o-btn o-btn--deeplink o-btn--deeplink-app o-btn--active u-ml--two u-overflow--hidden u-l u-relative js-deeplink--app'
                });

                if (linkActive === 'deo') {
                    linkApp.removeClass('o-btn--active');
                } else {

                }


                let linkAppHandler = $('<a>', {
                    'href': '#',
                    'class': 'u-none-i js-m-modal',
                    'data-deeplink-handler': 'app',
                    'data-modal-target': 'dl_App',
                    'data-modal-effect': 'slideUpIn'
                });

                $deeplink.append(linkAppHandler);


                linkApp.prepend(linkAppHtml);

                $('#desktop-slr-app-link').attr('href', linkAppDataDesktop);
                $('#mobile-slr-app-link').attr('href', linkAppDataMobile);


                if (linkActive === 'deo') {
                    $deeplink.find('.m-deeplinks').prepend(linkApp);
                } else {
                    $deeplink.find('.m-deeplinks').append(linkApp);
                }

            }

            if (linkFixed) {
                (function () {

                    const $scrollHeight = 80;

                    const $this = $('.m-deeplinks--fixed');

                    if ($this && $this.length) {

                        $(window).on("scroll", function () {
                            if ($(window).scrollTop() >= $scrollHeight) {
                                $this.addClass('m-deeplinks--active u-fade--active');
                            } else {
                                $this.removeClass('m-deeplinks--active u-fade--active');
                            }
                        });

                    }

                })();
            }

            // downloads slider
            const $downloads_slider = $('.js-m-deeplinks-downloads-slider', $deeplink);
            const $downloads_slides = $('.js-m-deeplinks-slide', $downloads_slider);
            const $downloads_slides_length = $downloads_slides.length;
            if ($(window).width() <= 1024 && $downloads_slides_length > 1) {
                let i = 0;
                $downloads_slides.css({
                    'opacity': 0,
                    'position': 'absolute'
                });

                requestAnimationFrame(animate);

                function animate () {
                    $downloads_slides.velocity({
                        opacity: 0
                    }, {
                        duration: 500,
                        delay: 1000
                    });

                    $downloads_slides.eq(i++).velocity({
                        opacity: 1
                    }, {
                        duration: 500
                    });

                    if (i === $downloads_slides_length) {
                        i = 0;
                    }

                    requestAnimationFrame(animate);
                }
            }
        } else if (dpVersion === 2) {
            const labelTitle = window.globalObj.deeplinks_label_title || 'Watch in VR';
            const colorScheme = window.globalObj.colorScheme || '';
            const label = `<div class="${colorScheme === 'dark' ? 'u-wh' : 'u-bl'} m-deeplinks-2--label u-fs--tw u-fw--semibold u-absolute u-pos--centered-x u-pos--t tablet:u-wh desktop:u-wh"><svg width="16" height="11" viewBox="0 0 16 11" xmlns="http://www.w3.org/2000/svg" class="o-ic o-ic--sprite u-fs--si u-align-y--t u-mr--one"><path d="M1.143.333h13.714c.589 0 1.074.434 1.136.99l.007.121v7.778c0 .573-.446 1.044-1.018 1.105l-.125.006H11.11c-.452 0-.856-.256-1.041-.65l-.045-.11-.94-2.744c-.334-.971-1.7-1.012-2.12-.122l-.049.122-.94 2.744a1.137 1.137 0 01-.963.754l-.122.006H1.143a1.132 1.132 0 01-1.136-.99L0 9.223V1.443C0 .872.446.4 1.018.34l.125-.007h13.714zm2.524 3.334a1.667 1.667 0 100 3.334 1.667 1.667 0 000-3.334zm8.666 0A1.667 1.667 0 1012.335 7a1.667 1.667 0 00-.002-3.334z" fill-rule="evenodd"/></svg> ${labelTitle}</div>`;
            const linkAppHtml = '<div class="u-fs--tw u-fw--semibold u-mt--half u-uppercase u-ml--six">SLR App</div>';
            const linkDeoHtml = '<div class="u-fs--tw u-fw--semibold u-mt--half u-uppercase u-ml--six">DeoVR</div>';

            let $deeplinkIn = $('<div>', {
                'class': 'm-deeplinks-2 u-nowrap u-flex u-flex-row u-align-i--start u-pt--five'
            });

            if (linkAbsolute) {
                $deeplinkIn.addClass('m-deeplinks-2--absolute u-absolute u-pos--centered-x');
            }

            let $deeplinkInFixed = $('<div>', {
                'class': 'm-deeplinks-2 m-deeplinks-2--fixed u-fixed u-nowrap u-flex-row u-align-i--start u-pt--five u-fade u-none tablet:u-flex desktop:u-flex'
            });

            // Change position if cookieNotice disabled or confirmed
            document.addEventListener('cookieNoticeDisable', function () {
                $deeplinkInFixed.removeClass('m-deeplinks-2--bottom-space');
            }, false);

            // Change position if cookieNotice enabled
            document.addEventListener('cookieNoticeEnable', function () {
                $deeplinkInFixed.addClass('m-deeplinks-2--bottom-space');
            }, false);

            $deeplink.append($deeplinkIn);
            if (linkFixed) {
                $deeplink.append($deeplinkInFixed);
            }

            if (linkDeoData && linkDeoData.length) {
                let deoIdAttr = null;

                if (showIdAttr) {
                    deoIdAttr = 'js-deeplink--deo';
                }

                let linkDeo = $('<a>', {
                    'href': '#',
                    'id': deoIdAttr,
                    'class': 'o-btn o-btn--deeplink-2 o-btn--deeplink-2-deo u-ml--two u-overflow--hidden u-relative u-l js-deeplink--deo'
                });

                let linkDeoHandler = $('<a>', {
                    'href': '#',
                    'class': 'u-none-i js-m-modal js-deo-handler',
                    'data-deeplink-handler': 'deo',
                    'data-modal-target': 'dl_Deo',
                    'data-modal-effect': 'slideUpIn'
                });

                $deeplink.append(linkDeoHandler);
                linkDeo.prepend(linkDeoHtml);

                $('#desktop-deovr-link').attr('href', linkDeoData);
                $('#mobile-deovr-link').attr('href', linkDeoData);



                $deeplink.find('.m-deeplinks-2').append(linkDeo);
            }

            if (linkAppDataMobile && linkAppDataMobile.length) {
                let appIdAttr = null;

                if (showIdAttr) {
                    appIdAttr = 'js-deeplink--app';
                }

                let linkApp = $('<a>', {
                    'href': '#',
                    'id': appIdAttr,
                    'class': 'o-btn o-btn--deeplink-2 o-btn--deeplink-2-app u-ml--two u-overflow--hidden u-l u-relative js-deeplink--app'
                });

                let linkAppHandler = $('<a>', {
                    'href': '#',
                    'class': 'u-none-i js-m-modal',
                    'data-deeplink-handler': 'app',
                    'data-modal-target': 'dl_App',
                    'data-modal-effect': 'slideUpIn'
                });

                $deeplink.append(linkAppHandler);
                linkApp.prepend(linkAppHtml);

                $('#desktop-slr-app-link').attr('href', linkAppDataDesktop);
                $('#mobile-slr-app-link').attr('href', linkAppDataMobile);

                $deeplink.find('.m-deeplinks-2').append(linkApp);
            }

            $deeplink.find('.m-deeplinks-2').prepend(label);

            if (linkFixed) {
                (function () {
                    const $scrollHeight = 80;

                    const $this = $('.m-deeplinks-2--fixed');
                    $this.find('.m-deeplinks-2--label').removeClass('tablet:u-wh desktop:u-wh');

                    if ($this && $this.length) {
                        $(window).on("scroll", function () {
                            if ($(window).scrollTop() >= $scrollHeight) {
                                $this.addClass('m-deeplinks-2--active u-fade--active');
                            } else {
                                $this.removeClass('m-deeplinks-2--active u-fade--active');
                            }
                        });
                    }
                })();
            }
        }
    });

})();

// Detect app
const DeeplinkHelper = {
    map: {},

    _map: function () {
        const $this = this;
        $this.map = {
            deeplink: '[data-ext="deeplink"]',
            // Generated links
            openSlrLink: $('a.js-deeplink--app'),
            openDeovrLink: $('a.js-deeplink--deo'),
            // Generated handlers
            handlerSlrLink: '[data-deeplink-handler="app"]',
            handlerDeovrLink: '[data-deeplink-handler="deo"]',
            // Modal deep links triggers
            desktopSlrAppLink: $('a#desktop-slr-app-link'),
            mobileSlrAppLink: $('a#mobile-slr-app-link'),
            desktopDeovrAppLink: $('a#desktop-deovr-link'),
            mobileDeovrAppLink: $('a#mobile-deovr-link'),
            // Container
            openSlrLinkMobile: $('.u-none--tablet-sm')
        };
    },

    init: function () {
        const $this = this;
        $this._map();

        // var openSlrLink = $this.map.desktopSlrAppLink.attr('href');
        // if ($this.map.openSlrLinkMobile.is(":visible")) {
        //     openSlrLink = $this.map.mobileSlrAppLink.attr('href');
        // }

        // var openDeovrLink = $this.map.desktopDeovrAppLink.attr('href');
        // if ($this.map.openSlrLinkMobile.is(":visible")) {
        //     openDeovrLink = $this.map.mobileDeovrAppLink.attr('href');
        // }

        $this.map.openSlrLink.click(function () {

            if (typeof $(this).parents($this.map.deeplink).data('deeplinkPause') !== 'undefined') {
                const webvrApp = window.app;

                if (typeof webvrApp !== 'undefined') {
                    webvrApp.bus.external.dispatchEvent({ type: "pause_press" });
                }
            }

            const $handlerSlrLink = $($this.map.handlerSlrLink, $(this).parents($this.map.deeplink));

            // Get slr app link from data attributes, not from popup
            let openSlrLink = $(this).parents($this.map.deeplink).attr("data-deeplink-desktop");

            if ($this.map.openSlrLinkMobile.is(":hidden")) {
                openSlrLink = $(this).parents($this.map.deeplink).attr("data-deeplink-mobile");
            }

            return $this.handlerClick(openSlrLink, function () {
                $handlerSlrLink.click();
            });
        });

        $this.map.openDeovrLink.click(function () {
            if (typeof $(this).parents($this.map.deeplink).data('deeplinkPause') !== 'undefined') {
                const webvrApp = window.app;

                if (typeof webvrApp !== 'undefined') {
                    webvrApp.bus.external.dispatchEvent({ type: "pause_press" });
                }
            }

            const $handlerDeovrLink = $($this.map.handlerDeovrLink, $(this).parents($this.map.deeplink));

            // Get deo link from [data-deeplink-deo], not from popup
            const openDeovrLink = $(this).parents($this.map.deeplink).attr("data-deeplink-deo");

            return $this.handlerClick(openDeovrLink, function () {
                $handlerDeovrLink.click();
            });
        });
    },

    handlerClick: function (appLink, handlerFunction) {
        const $this = this;

        $this.runAppLink(appLink, handlerFunction);

        return false;
    },

    /**
     * @param {string} appLink
     * @param {Function} [callbackFail]
     * @param {boolean} [runCallbackHard=false] Use this if you want to show the download dialog in any case
     */
    runAppLink: function (appLink, callbackFail, runCallbackHard) {
        let protocolFound = false,
            isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1,
            isIos = is_iOS();

        const _setProtocolFound = function () {
            protocolFound = true;
        };

        const windowsChecker = function () {
            const frame = document.createElement('iframe');

            try {
                frame.style.display = 'none';
                frame.src = appLink;
                document.body.appendChild(frame);
            } catch (e) {
                document.body.removeChild(frame);
            } finally {
                setTimeout(function () {
                    if (
                        ((protocolFound === false) || (runCallbackHard === true)) &&
                        callbackFail instanceof Function
                    ) {
                        callbackFail();
                    }

                    window.removeEventListener('blur', _setProtocolFound);
                    document.body.removeChild(frame);
                }, 450);
            }
        };

        const androidChecker = function () {
            window.location.href = appLink;

            setTimeout(function () {
                if (
                    ((protocolFound === false) || (runCallbackHard === true || isIos)) &&
                    callbackFail instanceof Function
                ) {
                    callbackFail();
                }

                window.removeEventListener('blur', _setProtocolFound);
            }, 700);
        };

        window.addEventListener('blur', _setProtocolFound);

        if (isAndroid || isIos) {
            androidChecker();
        } else {
            windowsChecker();
        }
    }
};

$(function () {
    DeeplinkHelper.init();
    $('.m-deeplinks--absolute').addClass('u-fade--active');
    $('.m-deeplinks-2--absolute').addClass('u-fade--active');
});

function is_iOS () {

    const iDevices = [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ];

    if (!!navigator.platform) {
        while (iDevices.length) {
            if (navigator.platform === iDevices.pop()) { return true; }
        }
    }

    return false;
}







